import * as React from 'react';
import NotificationsList from './NotificationsList';
import NotificationsStore from './Store';

export const NotificationsContext = React.createContext(new NotificationsStore());

const Notifications: React.FC = () => (
  <NotificationsContext.Consumer>
    {(store) => <NotificationsList store={store} />}
  </NotificationsContext.Consumer>
);

export default Notifications;
